import { Injectable } from '@angular/core';

@Injectable()
export class SettingService {

    get(name: string): string {
        return solid.setting.get(name);
    }

    getBoolean(name: string): boolean {
        return solid.setting.getBoolean(name);
    }
    
    getInt(name: string): number {
        return solid.setting.getInt(name);
    }

}